export default __webpack_public_path__ + "static/media/Ignite.4c64d45d.png";